<div class="sort-dropdown" [class.sort-dropdown--open]="isDropdownOpen">
  <div class="sort-dropdown__main">
    <span class="sort-dropdown__label">
      {{ 'filters.sort.label' | i18n }}:
    </span>

    <div
      class="sort-dropdown__dropdown"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
    >
      <button class="sort-dropdown__current-value" (click)="toggleDropdown()">
        {{ currentOption.text | i18n }}
      </button>

      <i class="sort-dropdown__icon material-icon material-icon--outlined">
        keyboard_arrow_down
      </i>
    </div>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayLockPosition]="true"
    [cdkConnectedOverlayViewportMargin]="16"
    [cdkConnectedOverlayPositions]="overlayPositions"
    (overlayOutsideClick)="close()"
    (detach)="close()"
  >
    <lib-dropdown-menu
      [options]="options"
      [currentOption]="currentOption"
      [highlightSelected]="true"
      (update)="select($event)"
      (tabOut)="close()"
    ></lib-dropdown-menu>
  </ng-template>
</div>
